import { __assign, __read, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useDefault } from "../_util/use-default";
import { useConfig } from "../_util/config-context";
import { useOutsideClick } from "../util/outsideclick";
import { MediaObject } from "../mediaobject";
import { Bubble } from "../bubble";
function PopConfirmClickTrigger(_a) {
    var childrenElementRef = _a.childrenElementRef, overlayElementRef = _a.overlayElementRef, visible = _a.visible, setVisible = _a.setVisible, _b = _a.openDelay, openDelay = _b === void 0 ? 0 : _b, _c = _a.closeDelay, closeDelay = _c === void 0 ? 0 : _c, render = _a.render;
    var _d = useOutsideClick([
        childrenElementRef,
        overlayElementRef,
    ]), listen = _d.listen, ignoreProps = _d.ignoreProps;
    listen(function () { return visible && setVisible(false, closeDelay); });
    return render({
        overlayProps: ignoreProps,
        childrenProps: {
            onClick: function () { return setVisible(!visible, openDelay); },
        },
    });
}
PopConfirmClickTrigger.displayName = "PopConfirmClickTrigger";
export function PopConfirm(_a) {
    var title = _a.title, message = _a.message, children = _a.children, footer = _a.footer, className = _a.className, disabled = _a.disabled, _visible = _a.visible, _onVisibleChange = _a.onVisibleChange, props = __rest(_a, ["title", "message", "children", "footer", "className", "disabled", "visible", "onVisibleChange"]);
    var classPrefix = useConfig().classPrefix;
    var _b = __read(useDefault(_visible, false, _onVisibleChange), 2), visible = _b[0], onVisibleChange = _b[1];
    var close = function () { return onVisibleChange(false); };
    var handleVisibleChange = function (value) {
        if (disabled) {
            return;
        }
        onVisibleChange(value);
    };
    return (React.createElement(Bubble, __assign({}, props, { visible: visible, onVisibleChange: handleVisibleChange, className: classNames(classPrefix + "-popconfirm", className), trigger: PopConfirmClickTrigger, content: React.createElement(React.Fragment, null,
            React.createElement("div", { className: classPrefix + "-popconfirm__body" },
                React.createElement(MediaObject, null,
                    title && (React.createElement("h3", { className: classPrefix + "-popconfirm__messagetitle" }, title)),
                    message && (React.createElement("div", { className: classPrefix + "-popconfirm__messagetext" }, message)))),
            footer && (React.createElement("div", { className: classPrefix + "-popconfirm__footer" }, typeof footer === "function" ? footer.call(null, close) : footer))) }), children));
}
PopConfirm.displayName = "PopConfirm";
//# sourceMappingURL=PopConfirm.js.map